import React from 'react';
import SettingsLayout from '../../components/SettingsLayout';
import { PlaceholderCard } from '../../components/PlaceholderCard';
import { Globe } from 'lucide-react';

const DomainPage = () => (
  <SettingsLayout title="Custom Domain" description="Serve your public roadmap and changelog from your own domain.">
    <PlaceholderCard
      icon={Globe}
      title="Custom domains unlock on Pro plan"
      description="Point roadmap.yourdomain.com at VibeSprint via CNAME — no branding, no third-party subdomain. Ships with public launch."
      badge="Pro plan"
      primaryLabel="See plans"
      primaryTo="/pricing"
      testIdBase="domain"
      waitlistFeature="custom_domain"
    />
  </SettingsLayout>
);

export default DomainPage;
